const API_VER = 'v1.0'
export const AuthEndpoints = {
    GET_VERIFY_CODE: `/oauth2/api/${API_VER}/image_verify_code`,
    AUTH_USER_LOGIN: `/oauth2/api/${API_VER}/token`,
    AUTH_USER_URI: `/auth/api/${API_VER}/users/`,
    AUTH_USER_SIGN_UP: `/auth/api/${API_VER}/users/sign_up/`,
    AUTH_USER_FORGOT_PWD: `/auth/api/${API_VER}/users/forgot_password/`,
    AUTH_USER_FORGOT_PWD_V2: `/auth/api/${API_VER}/users/reset_password_timeralo/`,
    AUTH_USER_SEND_VERIFY_CODE: `/auth/api/${API_VER}/users/send_verification_email/`,
    AUTH_USER_RESET_PASSWORD_V2: `/auth/api/${API_VER}/users/reset_employee_account_password/`,
    AUTH_USER_INFO_URI: `/auth/api/${API_VER}/users/info/`,
    AUTH_USER_SUPPORT_FEEDBACK: `/auth/api/${API_VER}/users/support_feedback/`,
    AUTH_USER_FIRST_LOGIN: `/auth/api/${API_VER}/users/first_login/`,
    AUTH_USER_FIRST_LOGIN_CHANGELOG: `/auth/api/${API_VER}/users/first_login_by_changelog/`,
    AUTH_USER_DELETE_URI: `/auth/api/${API_VER}/users/delete_account/`,
    AUTH_UPDATE_USER_INFO_URI: `/auth/api/${API_VER}/users/update_info/`,
    AUTH_USER_RESET_PASSWORD: `/auth/api/${API_VER}/users/reset_password/`,
    AUTH_USER_COMPANY: `/auth/api/${API_VER}/companies/`,
    AUTH_USER_COMPANY_CREATION: `/auth/api/${API_VER}/companies/sign_up/`,
    AUTH_USER_COMPANY_UPDATE: `/auth/api/${API_VER}/companies/update_info/`,
    AUTH_USER_COMPANY_INFO_URI: `/auth/api/${API_VER}/companies/info/`,
    AUTH_USER_SELECT_COMPANY: `/auth/api/${API_VER}/companies/switch_company_v2/`,
    AUTH_USER_DEFAULT_COMPANY: `/auth/api/${API_VER}/companies/get_default_company/`,
    AUTH_USER_UPDATE_COUNTRY: `/auth/api/${API_VER}/companies/update_country_state/`,
    AUTH_USER_GET_TIMEZONE_LIST: `/auth/api/${API_VER}/users/get_timezone_list/`,
    AUTH_USER_GET_TIMEZONE_BY_COUNTRY: `/auth/api/${API_VER}/users/timezone_list_by_country/`,
    AUTH_USER_GET_COUNTRY_LIST: `/auth/api/${API_VER}/users/get_country_list/`,
    AUTH_USER_COMPANY_DATE_FORMAT: `/auth/api/${API_VER}/companies/switch_date_format/`,
    AUTH_USER_COMPLIANCE_OPERATION: `/auth/api/${API_VER}/companies/compliance_operation/`,
    AUTH_USER_CHATBOT_TOKEN: `/auth/api/${API_VER}/companies/chat_bot_token/`,
    AUTH_USER_CHATBOT_FEEDBACK: `/auth/api/${API_VER}/companies/chat_bot_feedback/`,
}
